/** Sistema ERP's integrados */
export interface IntegrationErpSistema {
    id: number;
    nome: string;
}

export const integrationErpSistemaSemIntegracao: IntegrationErpSistema = {id: 1, nome: 'Sem Integração'};
export const integrationErpSistemaProManager: IntegrationErpSistema = {id: 2, nome: 'Pro Manager'};
export const integrationErpSistemaSCR: IntegrationErpSistema = {id: 3, nome: 'SCR'};
export const integrationErpSistemaProManager2: IntegrationErpSistema = {id: 4, nome: 'Pro Manager 2'};
export const integrationErpSistemaProManagerLegado: IntegrationErpSistema = {id: 5, nome: 'Pro Manager Legado'};

export const integrationErpSistemas: IntegrationErpSistema[] = [
    integrationErpSistemaSemIntegracao,
    integrationErpSistemaProManager,
    integrationErpSistemaSCR,
    integrationErpSistemaProManager2,
    integrationErpSistemaProManagerLegado
];

/** Verifica se é Sem Integração */
export function isIntegrationErpSistemaSemIntegracao(sistema: number): boolean {
    if (!sistema) {
        return false;
    }
    return sistema === integrationErpSistemaSemIntegracao.id;
}

/** Verifica se a integração é com o sistema Pro Manager */
export function isIntegrationErpSistemaProManager(sistema: number): boolean {
    if (!sistema) {
        return false;
    }
    return sistema === integrationErpSistemaProManager.id;
}

/** Verifica se a integração é com o sistema SCR */
export function isIntegrationErpSistemaSCR(sistema: number): boolean {
    if (!sistema) {
        return false;
    }
    return sistema === integrationErpSistemaSCR.id;
}

/** Verifica se a integração é com o sistema Pro Manager 2 */
export function isIntegrationErpSistemaProManager2(sistema: number): boolean {
    if (!sistema) {
        return false;
    }
    return sistema === integrationErpSistemaProManager2.id;
}

/** Verifica se a integração é com o sistema Pro Manager Legado */
export function isIntegrationErpSistemaProManagerLegado(sistema: number): boolean {
    if (!sistema) {
        return false;
    }
    return sistema === integrationErpSistemaProManagerLegado.id;
}
